import { Button, ButtonProps } from '@servicetitan/anvil2';
import { MouseEvent } from 'react';
import { DecisionDataStore } from '@servicetitan/financing-decision-shared';
import { redirectToPostApplication } from '@servicetitan/financing-utils-shared';

export const ViewOfferDetailsButton = ({ onClick, ...restButtonProps }: ButtonProps) => {
    const { decisionData } = DecisionDataStore.useStore();

    const handleClick = () => {
        const loanId = (decisionData?.loanId ?? '') || '0';
        redirectToPostApplication(loanId);
    };

    const combinedOnClick = (event: MouseEvent<HTMLButtonElement>) => {
        if (onClick) {
            onClick(event);
        }
        handleClick();
    };

    return (
        <Button onClick={combinedOnClick} {...restButtonProps}>
            View Offer Details
        </Button>
    );
};
